const initialState = {
  loggedUser: null,
  fetching: false,
  likes: [],
  requiredDetails: [],
  onSuccess: null
};

const user = (state = initialState, action) => {
  switch (action.type) {
  case 'FETCHING_USER':
    return {
      ...state,
      fetching: true
    };
  case 'SAVE_USER':
    return {
      ...state,
      loggedUser: action.user,
      fetching: false
    };
  case 'VALIDATE_USER':
    return {
      ...state,
      requiredDetails: action.requiredDetails,
      onSuccess: action.onSuccess,
      fetching: false
    };
  case 'LOGOUT_USER':
    return {
      ...state,
      loggedUser: action.user,
      fetching: action.fetching,
      requiredDetails: action.requiredDetails
    };
  case 'ADD_LIKE':
    return {
      ...state,
      likes: [...state.likes.filter(id => id !== action.profileId), action.profileId]
    };
  case 'REMOVE_LIKE':
    return {
      ...state,
      likes: [...state.likes.filter(id => id !== action.profileId)]
    };
  case 'SET_LIKES':
    return {
      ...state,
      likes: action.likes
    };
  case 'UPDATE_EMAIL_PREFERENCES':
    return {
      ...state,
      loggedUser: {
        ...state.loggedUser,
        preferences: {
          ...state.loggedUser.preferences,
          ...action.emailPreferences
        }
      }
    };
  case 'UPDATE_FB_UID':
    return {
      ...state,
      loggedUser: {
        ...state.loggedUser,
        fbUid: action.uid
      }
    };
  default:
    return state;
  }
};

export default user;
